// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================================
 * Sign-in / sign-up shell. White canvas, near-black ink, Vriti blue as the
 * only accent. Scoped to .vx-auth (always paired with .vx).
 * ========================================================================== */

.vx.vx-auth {
  --ink: #0b1020;
  --ink-2: #2a3142;
  --mute: #646c7e;
  --paper: #ffffff;
  --paper-2: #f7f8fa;
  --gray: #eef1f5;
  --tint: #eef3ff;
  --line: rgba(11, 16, 32, 0.08);
  --line-2: rgba(11, 16, 32, 0.16);
  --sig: #315bff;
  --sig-ink: #2448e0;
  --sig-bright: #4b6fff;
  --sig-soft: rgba(49, 91, 255, 0.1);
  --vx-col: clamp(420px, 36vw, 560px);
  --vx-pad: clamp(36px, 3.4vw, 64px);
  --vx-edge: clamp(28px, 3.4vw, 60px);

  display: flex;
  flex-direction: column;
  min-height: 100vh;
  min-height: 100dvh;
  background: var(--paper);
  color: var(--ink);
}

/* ------------------------------- Stage ---------------------------------- */

.vx-auth__stage {
  position: relative;
  z-index: 0;
  overflow: hidden;
  pointer-events: none;
}
.vx-auth__cloth,
.vx-fabric,
.vx-fabric__overlay {
  position: absolute;
  inset: 0;
}
.vx-fabric__canvas,
.vx-fabric__fallback {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  display: block;
}

/* ----------------------------- Annotations ------------------------------ */

.vx-note,
.vx-lens,
.vx-point {
  position: absolute;
  left: 0;
  top: 0;
  will-change: transform;
}
.vx-note__dot {
  position: absolute;
  left: -4.5px;
  top: -4.5px;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: #fff;
  box-shadow:
    0 0 0 1.5px var(--sig),
    0 0 0 6px rgba(49, 91, 255, 0.08);
}
.vx-note__dot::after {
  content: '';
  position: absolute;
  inset: -1.5px;
  border-radius: 50%;
  border: 1px solid var(--sig);
  animation: vx-ring 3.6s cubic-bezier(0.16, 1, 0.3, 1) infinite;
}
.vx-note:nth-child(odd) .vx-note__dot::after {
  animation-delay: 1.8s;
}
@keyframes vx-ring {
  0% {
    transform: scale(1);
    opacity: 0.7;
  }
  70%,
  100% {
    transform: scale(4.2);
    opacity: 0;
  }
}
.vx-note__leader {
  position: absolute;
  left: 0;
  top: 0;
  overflow: visible;
}
.vx-note__leader path {
  fill: none;
  stroke: var(--sig);
  stroke-opacity: 0.55;
  stroke-width: 1;
}
.vx-note__label {
  position: absolute;
  transform: translateY(-50%);
  white-space: nowrap;
}
.vx-note__label.is-west {
  transform: translate(-100%, -50%);
  text-align: right;
}
.vx-note__label > div {
  display: grid;
  gap: 4px;
  /* A light backing keeps the label readable over the moving cloth. */
  padding: 7px 11px 8px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.86);
  box-shadow:
    0 0 0 1px rgba(10, 10, 10, 0.06),
    0 6px 18px -10px rgba(10, 10, 10, 0.18);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
}
.vx-note__code {
  font-family: var(--f-mono);
  font-size: 9.5px;
  letter-spacing: 0.16em;
  color: var(--sig);
}
.vx-note__title {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  font-family: var(--f-mono);
  font-size: 11.5px;
  font-weight: 600;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--ink);
}
.is-west .vx-note__title {
  justify-content: flex-end;
}
.vx-note__meta {
  font-size: 12.5px;
  letter-spacing: -0.005em;
  color: #262626;
}
.vx-note__wave {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  height: 12px;
}
.vx-note__wave i {
  width: 1.5px;
  height: 100%;
  border-radius: 1px;
  background: var(--sig);
  transform: scaleY(0.25);
  animation: vx-wave 1.3s ease-in-out infinite alternate;
}
@keyframes vx-wave {
  to {
    transform: scaleY(1);
  }
}

.vx-lens__rings {
  position: absolute;
  left: -110px;
  top: -110px;
  width: 220px;
  height: 220px;
  overflow: visible;
}
.vx-lens__ticks,
.vx-lens__ring,
.vx-lens__scan,
.vx-lens__cross {
  fill: none;
}
.vx-lens__ticks {
  stroke: var(--ink);
  stroke-opacity: 0.35;
  stroke-dasharray: 1 5.5;
}
.vx-lens__ring {
  stroke: var(--ink);
  stroke-opacity: 0.12;
}
.vx-lens__cross {
  stroke: var(--ink);
  stroke-opacity: 0.3;
}
.vx-lens__scan {
  stroke: var(--sig);
  stroke-width: 1.5;
  stroke-linecap: round;
  stroke-dasharray: 12 88;
  animation: vx-scan 9s cubic-bezier(0.65, 0, 0.35, 1) infinite;
}
@keyframes vx-scan {
  to {
    stroke-dashoffset: -100;
  }
}
.vx-lens__core {
  fill: var(--sig);
}
.vx-lens__node {
  fill: #fff;
  stroke: var(--sig);
  stroke-width: 1.25;
  transform-box: fill-box;
  transform-origin: center;
  animation: vx-node 6s cubic-bezier(0.16, 1, 0.3, 1) infinite;
}
@keyframes vx-node {
  0%,
  100% {
    fill: #fff;
    transform: scale(1);
  }
  6% {
    fill: var(--sig);
    transform: scale(1.6);
  }
  22% {
    fill: var(--sig);
    transform: scale(1);
  }
  30% {
    fill: #fff;
  }
}
.vx-lens__label {
  position: absolute;
  left: 118px;
  top: -14px;
  display: grid;
  gap: 3px;
  font-family: var(--f-mono);
  font-size: 9.5px;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  white-space: nowrap;
  color: #0a0a0a;
  padding: 6px 10px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.86);
  box-shadow: 0 0 0 1px rgba(10, 10, 10, 0.06);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
}
.vx-lens__label > span:first-child {
  display: inline-flex;
  align-items: center;
  gap: 7px;
}
.vx-lens__sub {
  color: #404040;
}
.vx-lens__live {
  width: 5px;
  height: 5px;
  background: var(--sig);
  animation: vx-blink 1.6s steps(2, jump-none) infinite;
}
@keyframes vx-blink {
  50% {
    opacity: 0.15;
  }
}

.vx-links {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  overflow: visible;
  animation: vx-fade-in 1.4s 1.9s both;
}
.vx-links path {
  fill: none;
  stroke: var(--sig);
  stroke-opacity: 0.32;
  stroke-width: 1;
  stroke-dasharray: 2 6;
  animation: vx-flow 2.4s linear infinite;
}
@keyframes vx-flow {
  to {
    stroke-dashoffset: -16;
  }
}
@keyframes vx-fade-in {
  from {
    opacity: 0;
  }
}

.vx-point {
  width: 0;
  height: 0;
  opacity: 0.55;
}
.vx-point span {
  position: absolute;
  left: -2px;
  top: -2px;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: var(--sig);
  box-shadow: 0 0 0 3px rgba(49, 91, 255, 0.1);
  animation:
    vx-fade-in 1s both,
    vx-twinkle 5s ease-in-out infinite;
}
@keyframes vx-twinkle {
  50% {
    opacity: 0.35;
  }
}

/* ------------------------------ Header ---------------------------------- */

.vx-auth__top {
  position: relative;
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 18px 20px;
}
.vx-auth__brand {
  display: inline-flex;
  align-items: center;
  gap: 12px;
}
.vx-auth__brand img {
  width: 30px;
  height: 30px;
  border-radius: 50%;
}
.vx-auth__pill {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 24px;
  padding: 0 10px 0 9px;
  border-radius: 99px;
  background: rgba(255, 255, 255, 0.8);
  box-shadow: inset 0 0 0 1px var(--line-2);
  font-family: var(--f-mono);
  font-size: 10px;
  font-weight: 500;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  white-space: nowrap;
  color: var(--ink);
}
.vx-auth__pill i {
  width: 5px;
  height: 5px;
  background: var(--sig);
  transform: rotate(45deg);
}
.vx-auth__back {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 0;
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
  color: var(--ink-2);
  transition: color 0.3s;
}
.vx-auth__back span {
  transition: transform 0.5s var(--ease);
}
.vx-auth__back:hover,
.vx-auth__back:focus-visible {
  color: var(--sig);
}
.vx-auth__back:hover span {
  transform: translateX(-4px);
}

/* ------------------------------ Headline -------------------------------- */

.vx-auth__hero {
  position: relative;
  z-index: 2;
  pointer-events: none;
}
.vx-auth__eyebrow {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
  font-family: var(--f-mono);
  font-size: 10.5px;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: #0a0a0a;
  font-weight: 500;
}
.vx-auth__eyebrow i {
  width: 28px;
  height: 1px;
  background: var(--sig);
}
.vx-auth__headline {
  display: flex;
  flex-direction: column;
  font-size: clamp(2.5rem, 8.6vw, 4.4rem);
  font-weight: 600;
  line-height: 0.94;
  letter-spacing: -0.055em;
  color: #0a0a0a;
  /* A white halo so cloth lines never cut through the letters. */
  text-shadow:
    0 0 28px rgba(255, 255, 255, 0.95),
    0 0 10px rgba(255, 255, 255, 0.9);
}
.vx-auth__line {
  display: block;
}
.vx-auth__line--serif {
  margin-top: 0.04em;
  padding-left: 0.9em;
  font-family: var(--f-serif);
  font-style: italic;
  font-weight: 400;
  font-size: 1.1em;
  letter-spacing: -0.025em;
  line-height: 0.9;
  color: var(--sig);
}

/* ----------------------------- Form panel ------------------------------- */

.vx-auth__main {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 480px;
  margin: 0 auto;
  padding: 36px 20px 24px;
}
.vx-auth__panel {
  width: 100%;
}
.vx-auth__kicker {
  display: flex;
  align-items: center;
  gap: 10px;
  font-family: var(--f-mono);
  font-size: 10.5px;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: var(--ink-2);
}
.vx-auth__kicker .vx-dot {
  width: 6px;
  height: 6px;
}
.vx-auth__kicker::after {
  content: '';
  flex: 1;
  height: 1px;
  background: linear-gradient(90deg, var(--line-2), transparent);
}
.vx-auth__h1 {
  margin: 22px 0 12px;
  font-size: clamp(2.5rem, 3.6vw, 3.6rem);
  font-weight: 600;
  line-height: 0.95;
  letter-spacing: -0.055em;
  color: var(--ink);
}
.vx-auth__h1 em {
  font-family: var(--f-serif);
  font-style: italic;
  font-weight: 400;
  letter-spacing: -0.02em;
}
.vx-auth__sub {
  margin-bottom: 36px;
  font-size: 15.5px;
  color: var(--mute);
}
.vx-auth__form {
  display: grid;
  gap: 22px;
}
.vx-auth__label {
  position: relative;
  display: block;
  margin-bottom: 9px;
  font-family: var(--f-mono);
  font-size: 10.5px;
  font-weight: 500;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--ink-2);
  transition:
    color 0.35s var(--ease),
    transform 0.5s var(--ease);
}
.vx-auth__label::before {
  content: '';
  position: absolute;
  left: -12px;
  top: 50%;
  width: 5px;
  height: 5px;
  margin-top: -2.5px;
  background: var(--sig);
  transform: scale(0) rotate(45deg);
  transition: transform 0.5s var(--ease);
}
.vx-auth__form div:focus-within > .vx-auth__label,
.vx-auth__form div:focus-within > .vx-auth__labelrow > .vx-auth__label {
  color: var(--sig);
}
.vx-auth__form div:focus-within > .vx-auth__label::before,
.vx-auth__form div:focus-within > .vx-auth__labelrow > .vx-auth__label::before {
  transform: scale(1) rotate(45deg);
}
.vx-auth__labelrow {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}
.vx-auth__link {
  font-size: 13px;
  font-weight: 600;
  color: var(--sig);
  cursor: pointer;
  background: linear-gradient(currentColor, currentColor) 0 100% / 0 1px no-repeat;
  transition: background-size 0.5s var(--ease);
}
.vx-auth__link:hover,
.vx-auth__link:focus-visible {
  background-size: 100% 1px;
}
.vx-auth__alt {
  margin-top: 6px;
  text-align: center;
  font-size: 14px;
  color: var(--mute);
}
.vx-auth__foot {
  margin-top: 40px;
  font-family: var(--f-mono);
  font-size: 10px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--mute);
  text-align: center;
}

/* Sign-up: step indicator, hints, URL prefix, password pair. */
.vx-auth__steps {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 4px 0 22px;
  font-size: 13px;
  font-weight: 500;
  color: var(--mute);
}
.vx-auth__steps li {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
.vx-auth__steps li + li::before {
  content: '';
  width: 28px;
  height: 1px;
  margin-right: 2px;
  background: var(--line-2);
}
.vx-auth__steps span {
  display: grid;
  place-items: center;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  box-shadow: inset 0 0 0 1px var(--line-2);
  font-family: var(--f-mono);
  font-size: 11px;
}
.vx-auth__steps li.is-on {
  color: var(--ink);
  font-weight: 600;
}
.vx-auth__steps li.is-on span {
  background: var(--sig);
  color: #fff;
  box-shadow: none;
}
.vx-auth__hint {
  font-size: 12px;
  color: var(--mute);
  cursor: help;
  border-bottom: 1px dotted currentColor;
}
.vx-auth__prefix {
  font-size: 14px;
  color: var(--mute);
  font-family: var(--f-sans);
}
.vx-auth__pair {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}
.vx-auth__note {
  margin-top: -6px !important;
  font-size: 12px;
  color: var(--mute);
}

/* ------------------------------- Submit --------------------------------- */
/* Motion lives in AuthSubmit (framer-motion): fill sweep, label roll, arrow
   hand-off, magnetic pull. CSS only lays the layers out. */

.vx-submit {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 56px;
  margin-top: 6px;
  padding: 0 10px 0 22px;
  border: 0;
  border-radius: 12px;
  background: #2448ff;
  color: #fff;
  font-family: var(--f-sans);
  font-size: 13.5px;
  font-weight: 600;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  cursor: pointer;
  overflow: hidden;
  isolation: isolate;
  will-change: transform;
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.2),
    0 14px 28px -18px rgba(36, 72, 255, 0.85);
  transition: box-shadow 0.5s var(--ease);
}
.vx-submit:not(:disabled):hover {
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.2),
    0 18px 34px -16px rgba(36, 72, 255, 0.9);
}
.vx-submit__fill {
  position: absolute;
  inset: 0;
  z-index: -1;
  background: #1b38d6;
  transform-origin: 50% 100%;
  pointer-events: none;
}
.vx-submit__label {
  display: inline-block;
  height: 1.3em;
  line-height: 1.3em;
  overflow: hidden;
}
.vx-submit__track {
  display: flex;
  flex-direction: column;
}
.vx-submit__track > span {
  display: block;
  height: 1.3em;
}
.vx-auth .vx-submit:focus-visible {
  outline: 2px solid #2448ff;
  outline-offset: 3px;
}
.vx-submit:disabled {
  cursor: progress;
}
.vx-submit__arrows {
  position: relative;
  display: grid;
  width: 38px;
  height: 38px;
  border-radius: 9px;
  background: rgba(255, 255, 255, 0.14);
  font-size: 16px;
  letter-spacing: 0;
  overflow: hidden;
}
.vx-submit__arrows span {
  grid-area: 1 / 1;
  display: grid;
  place-items: center;
}
.vx-submit__progress {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 36%;
  height: 2px;
  background: rgba(255, 255, 255, 0.85);
  animation: vx-progress 1.1s cubic-bezier(0.65, 0, 0.35, 1) infinite;
}
@keyframes vx-progress {
  from {
    transform: translateX(-100%);
  }
  to {
    transform: translateX(290%);
  }
}

/* ------------------------------ Compact --------------------------------- */
/* Phone and tablet: the cloth becomes a header the nav sits on, the
   headline overlaps its lower edge, the form follows. */

@media (max-width: 1023px) {
  .vx-auth__stage {
    height: clamp(230px, 36vh, 300px);
    margin-top: -66px;
    -webkit-mask-image: linear-gradient(#000 62%, transparent);
    mask-image: linear-gradient(#000 62%, transparent);
  }
  .vx-auth__hero {
    margin-top: -64px;
    padding: 0 20px;
  }
  .vx-auth__eyebrow {
    margin-bottom: 14px;
    font-size: 9.5px;
    letter-spacing: 0.14em;
  }
  .vx-auth__h1 {
    font-size: clamp(2.2rem, 9vw, 3rem);
  }
}
@media (min-width: 640px) and (max-width: 1023px) {
  .vx-auth__top {
    padding: 22px 40px;
  }
  .vx-auth__stage {
    height: clamp(340px, 46vh, 480px);
  }
  .vx-auth__hero {
    padding: 0 40px;
  }
  .vx-auth__main {
    max-width: 520px;
    padding-top: 48px;
  }
}
@media (max-width: 480px) {
  .vx-auth__pair {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 360px) {
  .vx-auth__pill {
    display: none;
  }
}

/* ------------------------------ Desktop --------------------------------- */
/* The cloth fills the page; the form column floats on the right over a
   soft white veil, and the headline is set into the lower-left. */

@media (min-width: 1024px) {
  .vx-auth__stage {
    position: fixed;
    inset: 0;
  }
  .vx-auth__stage::after {
    content: '';
    position: absolute;
    inset: 0;
    background: radial-gradient(
        72% 58% at 0% 100%,
        rgba(255, 255, 255, 0.96),
        rgba(255, 255, 255, 0.78) 40%,
        transparent 74%
      ),
      linear-gradient(
        90deg,
        transparent calc(100% - var(--vx-col) - 200px),
        rgba(255, 255, 255, 0.9) calc(100% - var(--vx-col) + 24px)
      );
  }
  .vx-auth__top {
    position: fixed;
    top: 0;
    right: 0;
    width: var(--vx-col);
    padding: 30px var(--vx-pad);
  }
  .vx-auth__hero {
    position: fixed;
    left: var(--vx-edge);
    bottom: clamp(32px, 6.5vh, 72px);
    max-width: calc(100vw - var(--vx-col) - var(--vx-edge) * 2);
  }
  .vx-auth__eyebrow {
    margin-bottom: 26px;
  }
  .vx-auth__headline {
    /* Sized from the space beside the form so the first line never wraps. */
    font-size: clamp(2.8rem, calc((100vw - var(--vx-col) - var(--vx-edge) * 2) / 10), 6.6rem);
  }
  .vx-auth__main {
    width: var(--vx-col);
    max-width: none;
    min-height: 100vh;
    min-height: 100dvh;
    margin: 0 0 0 auto;
    padding: 112px var(--vx-pad) 28px;
    /* A solid surface: the cloth stops at the form instead of running behind it. */
    background: #ffffff;
    border-left: 1px solid rgba(10, 10, 10, 0.08);
    box-shadow: -32px 0 64px -40px rgba(10, 10, 10, 0.22);
  }
  .vx-auth__top {
    z-index: 3;
    background: #ffffff;
  }
  .vx-auth__panel {
    max-width: 420px;
    margin: auto 0;
    padding: 32px 0;
  }
  .vx-auth__foot {
    margin-top: 32px;
    text-align: left;
  }
}
@media (min-width: 1024px) and (max-height: 720px) {
  .vx-auth__headline {
    font-size: clamp(3rem, 4.6vw, 4.8rem);
  }
}

/* ------------------------------ Wide form ------------------------------ */
/* Sign-up: a wider column and a two-column field grid so the whole form
   fits on one screen. */

.vx-auth--wide .vx-auth__h1 {
  margin: 18px 0 10px;
  font-size: clamp(2.4rem, 3.3vw, 3.2rem);
}
.vx-auth--wide .vx-auth__sub {
  margin-bottom: 24px;
  font-size: 16px;
}
.vx-auth--wide .vx-auth__steps {
  margin: 0 0 22px;
}
.vx-auth--wide .vx-auth__form {
  gap: 20px;
}
.vx-auth--wide .vx-auth__pair {
  gap: 16px;
  align-items: start;
}
/* Keep the hint from making its label row taller than its neighbour's. */
.vx-auth--wide .vx-auth__labelrow {
  align-items: center;
  height: 16px;
  margin-bottom: 9px;
}
.vx-auth--wide .vx-auth__labelrow .vx-auth__label {
  margin-bottom: 0;
}
.vx-auth--wide .vx-auth__hint {
  line-height: 14px;
}
.vx-auth--wide .vx-auth__label {
  line-height: 16px;
}
.vx-auth--wide .vx-auth__prefix {
  font-size: 13px;
}
@media (min-width: 640px) and (max-width: 1023px) {
  .vx-auth--wide .vx-auth__main {
    max-width: 660px;
  }
}
@media (min-width: 1024px) {
  .vx.vx-auth--wide {
    --vx-col: clamp(560px, 47vw, 760px);
  }
  .vx-auth--wide .vx-auth__main {
    padding-top: 92px;
  }
  .vx-auth--wide .vx-auth__panel {
    max-width: 640px;
    padding: 8px 0;
  }
  .vx-auth--wide .vx-auth__foot {
    margin-top: 16px;
  }
}

/* Short desktop screens: tighten the sign-up form so it still fits. */
@media (min-width: 1024px) and (max-height: 820px) {
  .vx-auth--wide .vx-auth__main {
    padding-top: 80px;
    padding-bottom: 16px;
  }
  .vx-auth--wide .vx-auth__h1 {
    margin: 12px 0 6px;
    font-size: clamp(2.1rem, 2.6vw, 2.5rem);
  }
  .vx-auth--wide .vx-auth__sub {
    margin-bottom: 14px;
    font-size: 15px;
  }
  .vx-auth--wide .vx-auth__steps {
    margin-bottom: 14px;
  }
  .vx-auth--wide .vx-auth__form {
    gap: 14px;
  }
  .vx-auth--wide .MuiOutlinedInput-root {
    height: 46px;
  }
  .vx-auth--wide .vx-submit {
    height: 50px;
  }
  .vx-auth--wide .vx-auth__foot {
    margin-top: 10px;
  }
}

/* --------------------------- Reduced motion ----------------------------- */

@media (prefers-reduced-motion: reduce) {
  .vx-auth *,
  .vx-auth *::before,
  .vx-auth *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
  }
  .vx-submit {
    transition-duration: 0.2s;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ai-landing/auth/auth.css"],"names":[],"mappings":"AAAA;;;+EAG+E;;AAE/E;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,8BAA8B;EAC9B,gCAAgC;EAChC,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,kCAAkC;EAClC,mCAAmC;EACnC,kCAAkC;EAClC,mCAAmC;;EAEnC,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA,6EAA6E;;AAE7E;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,oBAAoB;AACtB;AACA;;;EAGE,kBAAkB;EAClB,QAAQ;AACV;AACA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA,6EAA6E;;AAE7E;;;EAGE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB;;qCAEmC;AACrC;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,4BAA4B;EAC5B,8DAA8D;AAChE;AACA;EACE,qBAAqB;AACvB;AACA;EACE;IACE,mBAAmB;IACnB,YAAY;EACd;EACA;;IAEE,qBAAqB;IACrB,UAAU;EACZ;AACF;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;EACE,iCAAiC;EACjC,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,QAAQ;EACR,oEAAoE;EACpE,qBAAqB;EACrB,kBAAkB;EAClB,qCAAqC;EACrC;;2CAEyC;EACzC,0BAA0B;EAC1B,kCAAkC;AACpC;AACA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;AACA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,sDAAsD;AACxD;AACA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;EACb,iBAAiB;AACnB;AACA;;;;EAIE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,uBAAuB;EACvB,6DAA6D;AAC/D;AACA;EACE;IACE,uBAAuB;EACzB;AACF;AACA;EACE,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;EACxB,4DAA4D;AAC9D;AACA;EACE;;IAEE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,gBAAgB;IAChB,qBAAqB;EACvB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,aAAa;EACb,QAAQ;EACR,0BAA0B;EAC1B,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;EACrC,4CAA4C;EAC5C,0BAA0B;EAC1B,kCAAkC;AACpC;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,cAAc;AAChB;AACA;EACE,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,qDAAqD;AACvD;AACA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,oCAAoC;AACtC;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,qBAAqB;EACrB,uCAAuC;AACzC;AACA;EACE;IACE,sBAAsB;EACxB;AACF;AACA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,4CAA4C;EAC5C;;sCAEoC;AACtC;AACA;EACE;IACE,aAAa;EACf;AACF;;AAEA,6EAA6E;;AAE7E;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,oCAAoC;EACpC,yCAAyC;EACzC,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,wBAAwB;AAC1B;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,sCAAsC;AACxC;AACA;;EAEE,iBAAiB;AACnB;AACA;EACE,2BAA2B;AAC7B;;AAEA,6EAA6E;;AAE7E;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,0BAA0B;EAC1B,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,WAAW;EACX,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uCAAuC;EACvC,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,cAAc;EACd,+DAA+D;EAC/D;;qCAEmC;AACrC;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,6EAA6E;;AAE7E;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,0BAA0B;EAC1B,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE,WAAW;EACX,OAAO;EACP,WAAW;EACX,8DAA8D;AAChE;AACA;EACE,mBAAmB;EACnB,uCAAuC;EACvC,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,iBAAiB;AACnB;AACA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB;;8BAE4B;AAC9B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,iCAAiC;EACjC,sCAAsC;AACxC;AACA;;EAEE,iBAAiB;AACnB;AACA;;EAEE,iCAAiC;AACnC;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,gFAAgF;EAChF,4CAA4C;AAC9C;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,WAAW;EACX,WAAW;EACX,WAAW;EACX,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yCAAyC;EACzC,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,sCAAsC;AACxC;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;AACpB;;AAEA,6EAA6E;AAC7E;2DAC2D;;AAE3D;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB;;6CAE2C;EAC3C,uCAAuC;AACzC;AACA;EACE;;4CAE0C;AAC5C;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,mBAAmB;EACnB,0BAA0B;EAC1B,oBAAoB;AACtB;AACA;EACE,qBAAqB;EACrB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,aAAa;AACf;AACA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,UAAU;EACV,WAAW;EACX,qCAAqC;EACrC,mEAAmE;AACrE;AACA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA,6EAA6E;AAC7E;wDACwD;;AAExD;EACE;IACE,iCAAiC;IACjC,iBAAiB;IACjB,0DAA0D;IAC1D,kDAAkD;EACpD;EACA;IACE,iBAAiB;IACjB,eAAe;EACjB;EACA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,sBAAsB;EACxB;EACA;IACE,mCAAmC;EACrC;AACF;AACA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,iCAAiC;EACnC;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;AACF;AACA;EACE;IACE,0BAA0B;EAC5B;AACF;AACA;EACE;IACE,aAAa;EACf;AACF;;AAEA,6EAA6E;AAC7E;kEACkE;;AAElE;EACE;IACE,eAAe;IACf,QAAQ;EACV;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR;;;;;;;;;;OAUG;EACL;EACA;IACE,eAAe;IACf,MAAM;IACN,QAAQ;IACR,oBAAoB;IACpB,2BAA2B;EAC7B;EACA;IACE,eAAe;IACf,oBAAoB;IACpB,gCAAgC;IAChC,2DAA2D;EAC7D;EACA;IACE,mBAAmB;EACrB;EACA;IACE,wEAAwE;IACxE,yFAAyF;EAC3F;EACA;IACE,oBAAoB;IACpB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,iCAAiC;IACjC,+EAA+E;IAC/E,mBAAmB;IACnB,6CAA6C;IAC7C,qDAAqD;EACvD;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,gBAAgB;IAChB,cAAc;IACd,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;AACF;AACA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA,4EAA4E;AAC5E;wBACwB;;AAExB;EACE,mBAAmB;EACnB,uCAAuC;AACzC;AACA;EACE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,SAAS;AACX;AACA;EACE,SAAS;EACT,kBAAkB;AACpB;AACA,yEAAyE;AACzE;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,mCAAmC;EACrC;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;IAChB,cAAc;EAChB;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA,sEAAsE;AACtE;EACE;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,uCAAuC;EACzC;EACA;IACE,mBAAmB;IACnB,eAAe;EACjB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,SAAS;EACX;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA,6EAA6E;;AAE7E;EACE;;;IAGE,qCAAqC;IACrC,uCAAuC;EACzC;EACA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":["/* ============================================================================\n * Sign-in / sign-up shell. White canvas, near-black ink, Vriti blue as the\n * only accent. Scoped to .vx-auth (always paired with .vx).\n * ========================================================================== */\n\n.vx.vx-auth {\n  --ink: #0b1020;\n  --ink-2: #2a3142;\n  --mute: #646c7e;\n  --paper: #ffffff;\n  --paper-2: #f7f8fa;\n  --gray: #eef1f5;\n  --tint: #eef3ff;\n  --line: rgba(11, 16, 32, 0.08);\n  --line-2: rgba(11, 16, 32, 0.16);\n  --sig: #315bff;\n  --sig-ink: #2448e0;\n  --sig-bright: #4b6fff;\n  --sig-soft: rgba(49, 91, 255, 0.1);\n  --vx-col: clamp(420px, 36vw, 560px);\n  --vx-pad: clamp(36px, 3.4vw, 64px);\n  --vx-edge: clamp(28px, 3.4vw, 60px);\n\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  min-height: 100dvh;\n  background: var(--paper);\n  color: var(--ink);\n}\n\n/* ------------------------------- Stage ---------------------------------- */\n\n.vx-auth__stage {\n  position: relative;\n  z-index: 0;\n  overflow: hidden;\n  pointer-events: none;\n}\n.vx-auth__cloth,\n.vx-fabric,\n.vx-fabric__overlay {\n  position: absolute;\n  inset: 0;\n}\n.vx-fabric__canvas,\n.vx-fabric__fallback {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  display: block;\n}\n\n/* ----------------------------- Annotations ------------------------------ */\n\n.vx-note,\n.vx-lens,\n.vx-point {\n  position: absolute;\n  left: 0;\n  top: 0;\n  will-change: transform;\n}\n.vx-note__dot {\n  position: absolute;\n  left: -4.5px;\n  top: -4.5px;\n  width: 9px;\n  height: 9px;\n  border-radius: 50%;\n  background: #fff;\n  box-shadow:\n    0 0 0 1.5px var(--sig),\n    0 0 0 6px rgba(49, 91, 255, 0.08);\n}\n.vx-note__dot::after {\n  content: '';\n  position: absolute;\n  inset: -1.5px;\n  border-radius: 50%;\n  border: 1px solid var(--sig);\n  animation: vx-ring 3.6s cubic-bezier(0.16, 1, 0.3, 1) infinite;\n}\n.vx-note:nth-child(odd) .vx-note__dot::after {\n  animation-delay: 1.8s;\n}\n@keyframes vx-ring {\n  0% {\n    transform: scale(1);\n    opacity: 0.7;\n  }\n  70%,\n  100% {\n    transform: scale(4.2);\n    opacity: 0;\n  }\n}\n.vx-note__leader {\n  position: absolute;\n  left: 0;\n  top: 0;\n  overflow: visible;\n}\n.vx-note__leader path {\n  fill: none;\n  stroke: var(--sig);\n  stroke-opacity: 0.55;\n  stroke-width: 1;\n}\n.vx-note__label {\n  position: absolute;\n  transform: translateY(-50%);\n  white-space: nowrap;\n}\n.vx-note__label.is-west {\n  transform: translate(-100%, -50%);\n  text-align: right;\n}\n.vx-note__label > div {\n  display: grid;\n  gap: 4px;\n  /* A light backing keeps the label readable over the moving cloth. */\n  padding: 7px 11px 8px;\n  border-radius: 8px;\n  background: rgba(255, 255, 255, 0.86);\n  box-shadow:\n    0 0 0 1px rgba(10, 10, 10, 0.06),\n    0 6px 18px -10px rgba(10, 10, 10, 0.18);\n  backdrop-filter: blur(6px);\n  -webkit-backdrop-filter: blur(6px);\n}\n.vx-note__code {\n  font-family: var(--f-mono);\n  font-size: 9.5px;\n  letter-spacing: 0.16em;\n  color: var(--sig);\n}\n.vx-note__title {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  font-family: var(--f-mono);\n  font-size: 11.5px;\n  font-weight: 600;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--ink);\n}\n.is-west .vx-note__title {\n  justify-content: flex-end;\n}\n.vx-note__meta {\n  font-size: 12.5px;\n  letter-spacing: -0.005em;\n  color: #262626;\n}\n.vx-note__wave {\n  display: inline-flex;\n  align-items: center;\n  gap: 2px;\n  height: 12px;\n}\n.vx-note__wave i {\n  width: 1.5px;\n  height: 100%;\n  border-radius: 1px;\n  background: var(--sig);\n  transform: scaleY(0.25);\n  animation: vx-wave 1.3s ease-in-out infinite alternate;\n}\n@keyframes vx-wave {\n  to {\n    transform: scaleY(1);\n  }\n}\n\n.vx-lens__rings {\n  position: absolute;\n  left: -110px;\n  top: -110px;\n  width: 220px;\n  height: 220px;\n  overflow: visible;\n}\n.vx-lens__ticks,\n.vx-lens__ring,\n.vx-lens__scan,\n.vx-lens__cross {\n  fill: none;\n}\n.vx-lens__ticks {\n  stroke: var(--ink);\n  stroke-opacity: 0.35;\n  stroke-dasharray: 1 5.5;\n}\n.vx-lens__ring {\n  stroke: var(--ink);\n  stroke-opacity: 0.12;\n}\n.vx-lens__cross {\n  stroke: var(--ink);\n  stroke-opacity: 0.3;\n}\n.vx-lens__scan {\n  stroke: var(--sig);\n  stroke-width: 1.5;\n  stroke-linecap: round;\n  stroke-dasharray: 12 88;\n  animation: vx-scan 9s cubic-bezier(0.65, 0, 0.35, 1) infinite;\n}\n@keyframes vx-scan {\n  to {\n    stroke-dashoffset: -100;\n  }\n}\n.vx-lens__core {\n  fill: var(--sig);\n}\n.vx-lens__node {\n  fill: #fff;\n  stroke: var(--sig);\n  stroke-width: 1.25;\n  transform-box: fill-box;\n  transform-origin: center;\n  animation: vx-node 6s cubic-bezier(0.16, 1, 0.3, 1) infinite;\n}\n@keyframes vx-node {\n  0%,\n  100% {\n    fill: #fff;\n    transform: scale(1);\n  }\n  6% {\n    fill: var(--sig);\n    transform: scale(1.6);\n  }\n  22% {\n    fill: var(--sig);\n    transform: scale(1);\n  }\n  30% {\n    fill: #fff;\n  }\n}\n.vx-lens__label {\n  position: absolute;\n  left: 118px;\n  top: -14px;\n  display: grid;\n  gap: 3px;\n  font-family: var(--f-mono);\n  font-size: 9.5px;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  white-space: nowrap;\n  color: #0a0a0a;\n  padding: 6px 10px;\n  border-radius: 8px;\n  background: rgba(255, 255, 255, 0.86);\n  box-shadow: 0 0 0 1px rgba(10, 10, 10, 0.06);\n  backdrop-filter: blur(6px);\n  -webkit-backdrop-filter: blur(6px);\n}\n.vx-lens__label > span:first-child {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n}\n.vx-lens__sub {\n  color: #404040;\n}\n.vx-lens__live {\n  width: 5px;\n  height: 5px;\n  background: var(--sig);\n  animation: vx-blink 1.6s steps(2, jump-none) infinite;\n}\n@keyframes vx-blink {\n  50% {\n    opacity: 0.15;\n  }\n}\n\n.vx-links {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  overflow: visible;\n  animation: vx-fade-in 1.4s 1.9s both;\n}\n.vx-links path {\n  fill: none;\n  stroke: var(--sig);\n  stroke-opacity: 0.32;\n  stroke-width: 1;\n  stroke-dasharray: 2 6;\n  animation: vx-flow 2.4s linear infinite;\n}\n@keyframes vx-flow {\n  to {\n    stroke-dashoffset: -16;\n  }\n}\n@keyframes vx-fade-in {\n  from {\n    opacity: 0;\n  }\n}\n\n.vx-point {\n  width: 0;\n  height: 0;\n  opacity: 0.55;\n}\n.vx-point span {\n  position: absolute;\n  left: -2px;\n  top: -2px;\n  width: 4px;\n  height: 4px;\n  border-radius: 50%;\n  background: var(--sig);\n  box-shadow: 0 0 0 3px rgba(49, 91, 255, 0.1);\n  animation:\n    vx-fade-in 1s both,\n    vx-twinkle 5s ease-in-out infinite;\n}\n@keyframes vx-twinkle {\n  50% {\n    opacity: 0.35;\n  }\n}\n\n/* ------------------------------ Header ---------------------------------- */\n\n.vx-auth__top {\n  position: relative;\n  z-index: 3;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 18px 20px;\n}\n.vx-auth__brand {\n  display: inline-flex;\n  align-items: center;\n  gap: 12px;\n}\n.vx-auth__brand img {\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n}\n.vx-auth__pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  height: 24px;\n  padding: 0 10px 0 9px;\n  border-radius: 99px;\n  background: rgba(255, 255, 255, 0.8);\n  box-shadow: inset 0 0 0 1px var(--line-2);\n  font-family: var(--f-mono);\n  font-size: 10px;\n  font-weight: 500;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  white-space: nowrap;\n  color: var(--ink);\n}\n.vx-auth__pill i {\n  width: 5px;\n  height: 5px;\n  background: var(--sig);\n  transform: rotate(45deg);\n}\n.vx-auth__back {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 0;\n  font-size: 13px;\n  font-weight: 500;\n  white-space: nowrap;\n  color: var(--ink-2);\n  transition: color 0.3s;\n}\n.vx-auth__back span {\n  transition: transform 0.5s var(--ease);\n}\n.vx-auth__back:hover,\n.vx-auth__back:focus-visible {\n  color: var(--sig);\n}\n.vx-auth__back:hover span {\n  transform: translateX(-4px);\n}\n\n/* ------------------------------ Headline -------------------------------- */\n\n.vx-auth__hero {\n  position: relative;\n  z-index: 2;\n  pointer-events: none;\n}\n.vx-auth__eyebrow {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 20px;\n  font-family: var(--f-mono);\n  font-size: 10.5px;\n  letter-spacing: 0.18em;\n  text-transform: uppercase;\n  color: #0a0a0a;\n  font-weight: 500;\n}\n.vx-auth__eyebrow i {\n  width: 28px;\n  height: 1px;\n  background: var(--sig);\n}\n.vx-auth__headline {\n  display: flex;\n  flex-direction: column;\n  font-size: clamp(2.5rem, 8.6vw, 4.4rem);\n  font-weight: 600;\n  line-height: 0.94;\n  letter-spacing: -0.055em;\n  color: #0a0a0a;\n  /* A white halo so cloth lines never cut through the letters. */\n  text-shadow:\n    0 0 28px rgba(255, 255, 255, 0.95),\n    0 0 10px rgba(255, 255, 255, 0.9);\n}\n.vx-auth__line {\n  display: block;\n}\n.vx-auth__line--serif {\n  margin-top: 0.04em;\n  padding-left: 0.9em;\n  font-family: var(--f-serif);\n  font-style: italic;\n  font-weight: 400;\n  font-size: 1.1em;\n  letter-spacing: -0.025em;\n  line-height: 0.9;\n  color: var(--sig);\n}\n\n/* ----------------------------- Form panel ------------------------------- */\n\n.vx-auth__main {\n  position: relative;\n  z-index: 2;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  max-width: 480px;\n  margin: 0 auto;\n  padding: 36px 20px 24px;\n}\n.vx-auth__panel {\n  width: 100%;\n}\n.vx-auth__kicker {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-family: var(--f-mono);\n  font-size: 10.5px;\n  letter-spacing: 0.18em;\n  text-transform: uppercase;\n  color: var(--ink-2);\n}\n.vx-auth__kicker .vx-dot {\n  width: 6px;\n  height: 6px;\n}\n.vx-auth__kicker::after {\n  content: '';\n  flex: 1;\n  height: 1px;\n  background: linear-gradient(90deg, var(--line-2), transparent);\n}\n.vx-auth__h1 {\n  margin: 22px 0 12px;\n  font-size: clamp(2.5rem, 3.6vw, 3.6rem);\n  font-weight: 600;\n  line-height: 0.95;\n  letter-spacing: -0.055em;\n  color: var(--ink);\n}\n.vx-auth__h1 em {\n  font-family: var(--f-serif);\n  font-style: italic;\n  font-weight: 400;\n  letter-spacing: -0.02em;\n}\n.vx-auth__sub {\n  margin-bottom: 36px;\n  font-size: 15.5px;\n  color: var(--mute);\n}\n.vx-auth__form {\n  display: grid;\n  gap: 22px;\n}\n.vx-auth__label {\n  position: relative;\n  display: block;\n  margin-bottom: 9px;\n  font-family: var(--f-mono);\n  font-size: 10.5px;\n  font-weight: 500;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--ink-2);\n  transition:\n    color 0.35s var(--ease),\n    transform 0.5s var(--ease);\n}\n.vx-auth__label::before {\n  content: '';\n  position: absolute;\n  left: -12px;\n  top: 50%;\n  width: 5px;\n  height: 5px;\n  margin-top: -2.5px;\n  background: var(--sig);\n  transform: scale(0) rotate(45deg);\n  transition: transform 0.5s var(--ease);\n}\n.vx-auth__form div:focus-within > .vx-auth__label,\n.vx-auth__form div:focus-within > .vx-auth__labelrow > .vx-auth__label {\n  color: var(--sig);\n}\n.vx-auth__form div:focus-within > .vx-auth__label::before,\n.vx-auth__form div:focus-within > .vx-auth__labelrow > .vx-auth__label::before {\n  transform: scale(1) rotate(45deg);\n}\n.vx-auth__labelrow {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n}\n.vx-auth__link {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--sig);\n  cursor: pointer;\n  background: linear-gradient(currentColor, currentColor) 0 100% / 0 1px no-repeat;\n  transition: background-size 0.5s var(--ease);\n}\n.vx-auth__link:hover,\n.vx-auth__link:focus-visible {\n  background-size: 100% 1px;\n}\n.vx-auth__alt {\n  margin-top: 6px;\n  text-align: center;\n  font-size: 14px;\n  color: var(--mute);\n}\n.vx-auth__foot {\n  margin-top: 40px;\n  font-family: var(--f-mono);\n  font-size: 10px;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: var(--mute);\n  text-align: center;\n}\n\n/* Sign-up: step indicator, hints, URL prefix, password pair. */\n.vx-auth__steps {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin: 4px 0 22px;\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--mute);\n}\n.vx-auth__steps li {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n.vx-auth__steps li + li::before {\n  content: '';\n  width: 28px;\n  height: 1px;\n  margin-right: 2px;\n  background: var(--line-2);\n}\n.vx-auth__steps span {\n  display: grid;\n  place-items: center;\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  box-shadow: inset 0 0 0 1px var(--line-2);\n  font-family: var(--f-mono);\n  font-size: 11px;\n}\n.vx-auth__steps li.is-on {\n  color: var(--ink);\n  font-weight: 600;\n}\n.vx-auth__steps li.is-on span {\n  background: var(--sig);\n  color: #fff;\n  box-shadow: none;\n}\n.vx-auth__hint {\n  font-size: 12px;\n  color: var(--mute);\n  cursor: help;\n  border-bottom: 1px dotted currentColor;\n}\n.vx-auth__prefix {\n  font-size: 14px;\n  color: var(--mute);\n  font-family: var(--f-sans);\n}\n.vx-auth__pair {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n}\n.vx-auth__note {\n  margin-top: -6px !important;\n  font-size: 12px;\n  color: var(--mute);\n}\n\n/* ------------------------------- Submit --------------------------------- */\n/* Motion lives in AuthSubmit (framer-motion): fill sweep, label roll, arrow\n   hand-off, magnetic pull. CSS only lays the layers out. */\n\n.vx-submit {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  height: 56px;\n  margin-top: 6px;\n  padding: 0 10px 0 22px;\n  border: 0;\n  border-radius: 12px;\n  background: #2448ff;\n  color: #fff;\n  font-family: var(--f-sans);\n  font-size: 13.5px;\n  font-weight: 600;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  cursor: pointer;\n  overflow: hidden;\n  isolation: isolate;\n  will-change: transform;\n  box-shadow:\n    inset 0 1px 0 rgba(255, 255, 255, 0.2),\n    0 14px 28px -18px rgba(36, 72, 255, 0.85);\n  transition: box-shadow 0.5s var(--ease);\n}\n.vx-submit:not(:disabled):hover {\n  box-shadow:\n    inset 0 1px 0 rgba(255, 255, 255, 0.2),\n    0 18px 34px -16px rgba(36, 72, 255, 0.9);\n}\n.vx-submit__fill {\n  position: absolute;\n  inset: 0;\n  z-index: -1;\n  background: #1b38d6;\n  transform-origin: 50% 100%;\n  pointer-events: none;\n}\n.vx-submit__label {\n  display: inline-block;\n  height: 1.3em;\n  line-height: 1.3em;\n  overflow: hidden;\n}\n.vx-submit__track {\n  display: flex;\n  flex-direction: column;\n}\n.vx-submit__track > span {\n  display: block;\n  height: 1.3em;\n}\n.vx-auth .vx-submit:focus-visible {\n  outline: 2px solid #2448ff;\n  outline-offset: 3px;\n}\n.vx-submit:disabled {\n  cursor: progress;\n}\n.vx-submit__arrows {\n  position: relative;\n  display: grid;\n  width: 38px;\n  height: 38px;\n  border-radius: 9px;\n  background: rgba(255, 255, 255, 0.14);\n  font-size: 16px;\n  letter-spacing: 0;\n  overflow: hidden;\n}\n.vx-submit__arrows span {\n  grid-area: 1 / 1;\n  display: grid;\n  place-items: center;\n}\n.vx-submit__progress {\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  width: 36%;\n  height: 2px;\n  background: rgba(255, 255, 255, 0.85);\n  animation: vx-progress 1.1s cubic-bezier(0.65, 0, 0.35, 1) infinite;\n}\n@keyframes vx-progress {\n  from {\n    transform: translateX(-100%);\n  }\n  to {\n    transform: translateX(290%);\n  }\n}\n\n/* ------------------------------ Compact --------------------------------- */\n/* Phone and tablet: the cloth becomes a header the nav sits on, the\n   headline overlaps its lower edge, the form follows. */\n\n@media (max-width: 1023px) {\n  .vx-auth__stage {\n    height: clamp(230px, 36vh, 300px);\n    margin-top: -66px;\n    -webkit-mask-image: linear-gradient(#000 62%, transparent);\n    mask-image: linear-gradient(#000 62%, transparent);\n  }\n  .vx-auth__hero {\n    margin-top: -64px;\n    padding: 0 20px;\n  }\n  .vx-auth__eyebrow {\n    margin-bottom: 14px;\n    font-size: 9.5px;\n    letter-spacing: 0.14em;\n  }\n  .vx-auth__h1 {\n    font-size: clamp(2.2rem, 9vw, 3rem);\n  }\n}\n@media (min-width: 640px) and (max-width: 1023px) {\n  .vx-auth__top {\n    padding: 22px 40px;\n  }\n  .vx-auth__stage {\n    height: clamp(340px, 46vh, 480px);\n  }\n  .vx-auth__hero {\n    padding: 0 40px;\n  }\n  .vx-auth__main {\n    max-width: 520px;\n    padding-top: 48px;\n  }\n}\n@media (max-width: 480px) {\n  .vx-auth__pair {\n    grid-template-columns: 1fr;\n  }\n}\n@media (max-width: 360px) {\n  .vx-auth__pill {\n    display: none;\n  }\n}\n\n/* ------------------------------ Desktop --------------------------------- */\n/* The cloth fills the page; the form column floats on the right over a\n   soft white veil, and the headline is set into the lower-left. */\n\n@media (min-width: 1024px) {\n  .vx-auth__stage {\n    position: fixed;\n    inset: 0;\n  }\n  .vx-auth__stage::after {\n    content: '';\n    position: absolute;\n    inset: 0;\n    background: radial-gradient(\n        72% 58% at 0% 100%,\n        rgba(255, 255, 255, 0.96),\n        rgba(255, 255, 255, 0.78) 40%,\n        transparent 74%\n      ),\n      linear-gradient(\n        90deg,\n        transparent calc(100% - var(--vx-col) - 200px),\n        rgba(255, 255, 255, 0.9) calc(100% - var(--vx-col) + 24px)\n      );\n  }\n  .vx-auth__top {\n    position: fixed;\n    top: 0;\n    right: 0;\n    width: var(--vx-col);\n    padding: 30px var(--vx-pad);\n  }\n  .vx-auth__hero {\n    position: fixed;\n    left: var(--vx-edge);\n    bottom: clamp(32px, 6.5vh, 72px);\n    max-width: calc(100vw - var(--vx-col) - var(--vx-edge) * 2);\n  }\n  .vx-auth__eyebrow {\n    margin-bottom: 26px;\n  }\n  .vx-auth__headline {\n    /* Sized from the space beside the form so the first line never wraps. */\n    font-size: clamp(2.8rem, calc((100vw - var(--vx-col) - var(--vx-edge) * 2) / 10), 6.6rem);\n  }\n  .vx-auth__main {\n    width: var(--vx-col);\n    max-width: none;\n    min-height: 100vh;\n    min-height: 100dvh;\n    margin: 0 0 0 auto;\n    padding: 112px var(--vx-pad) 28px;\n    /* A solid surface: the cloth stops at the form instead of running behind it. */\n    background: #ffffff;\n    border-left: 1px solid rgba(10, 10, 10, 0.08);\n    box-shadow: -32px 0 64px -40px rgba(10, 10, 10, 0.22);\n  }\n  .vx-auth__top {\n    z-index: 3;\n    background: #ffffff;\n  }\n  .vx-auth__panel {\n    max-width: 420px;\n    margin: auto 0;\n    padding: 32px 0;\n  }\n  .vx-auth__foot {\n    margin-top: 32px;\n    text-align: left;\n  }\n}\n@media (min-width: 1024px) and (max-height: 720px) {\n  .vx-auth__headline {\n    font-size: clamp(3rem, 4.6vw, 4.8rem);\n  }\n}\n\n/* ------------------------------ Wide form ------------------------------ */\n/* Sign-up: a wider column and a two-column field grid so the whole form\n   fits on one screen. */\n\n.vx-auth--wide .vx-auth__h1 {\n  margin: 18px 0 10px;\n  font-size: clamp(2.4rem, 3.3vw, 3.2rem);\n}\n.vx-auth--wide .vx-auth__sub {\n  margin-bottom: 24px;\n  font-size: 16px;\n}\n.vx-auth--wide .vx-auth__steps {\n  margin: 0 0 22px;\n}\n.vx-auth--wide .vx-auth__form {\n  gap: 20px;\n}\n.vx-auth--wide .vx-auth__pair {\n  gap: 16px;\n  align-items: start;\n}\n/* Keep the hint from making its label row taller than its neighbour's. */\n.vx-auth--wide .vx-auth__labelrow {\n  align-items: center;\n  height: 16px;\n  margin-bottom: 9px;\n}\n.vx-auth--wide .vx-auth__labelrow .vx-auth__label {\n  margin-bottom: 0;\n}\n.vx-auth--wide .vx-auth__hint {\n  line-height: 14px;\n}\n.vx-auth--wide .vx-auth__label {\n  line-height: 16px;\n}\n.vx-auth--wide .vx-auth__prefix {\n  font-size: 13px;\n}\n@media (min-width: 640px) and (max-width: 1023px) {\n  .vx-auth--wide .vx-auth__main {\n    max-width: 660px;\n  }\n}\n@media (min-width: 1024px) {\n  .vx.vx-auth--wide {\n    --vx-col: clamp(560px, 47vw, 760px);\n  }\n  .vx-auth--wide .vx-auth__main {\n    padding-top: 92px;\n  }\n  .vx-auth--wide .vx-auth__panel {\n    max-width: 640px;\n    padding: 8px 0;\n  }\n  .vx-auth--wide .vx-auth__foot {\n    margin-top: 16px;\n  }\n}\n\n/* Short desktop screens: tighten the sign-up form so it still fits. */\n@media (min-width: 1024px) and (max-height: 820px) {\n  .vx-auth--wide .vx-auth__main {\n    padding-top: 80px;\n    padding-bottom: 16px;\n  }\n  .vx-auth--wide .vx-auth__h1 {\n    margin: 12px 0 6px;\n    font-size: clamp(2.1rem, 2.6vw, 2.5rem);\n  }\n  .vx-auth--wide .vx-auth__sub {\n    margin-bottom: 14px;\n    font-size: 15px;\n  }\n  .vx-auth--wide .vx-auth__steps {\n    margin-bottom: 14px;\n  }\n  .vx-auth--wide .vx-auth__form {\n    gap: 14px;\n  }\n  .vx-auth--wide .MuiOutlinedInput-root {\n    height: 46px;\n  }\n  .vx-auth--wide .vx-submit {\n    height: 50px;\n  }\n  .vx-auth--wide .vx-auth__foot {\n    margin-top: 10px;\n  }\n}\n\n/* --------------------------- Reduced motion ----------------------------- */\n\n@media (prefers-reduced-motion: reduce) {\n  .vx-auth *,\n  .vx-auth *::before,\n  .vx-auth *::after {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n  }\n  .vx-submit {\n    transition-duration: 0.2s;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
